import React, { useState, useEffect } from 'react';
import Label from './Label';
import { FormLabel } from '@blockstack/ui';
import Input from './Input';
// @ts-ignore
import Slider from 'rc-slider/lib/Slider';
// @ts-ignore
import 'rc-slider/assets/index.css';

interface Props {
    label: string;
    value: number;
    min: number;
    max: number;
    step: number;
    ExtraInput?: React.Component;
    tooltip?: string;
    maxLength?: number;
    currencyLabel?: string;
    style?: object;
    onChange: (value: number) => void;
}

export const SliderValue: React.FC<Props> = (props: Props) => {
    const { label, min, max, step, tooltip, maxLength, currencyLabel, style, onChange } = props;
    const [value, setValue] = useState(props.value);

    useEffect(() => {
        setValue(props.value);
    }, [props.value]);

    return (
        <div style={style}>
            <div>
                <FormLabel fontWeight="bold" mb="8px">
                    {props.tooltip && <Label label={label} tooltip={tooltip} />}
                </FormLabel>
            </div>
            <div style={{ display: 'flex', width: '100%' }}>
                <div
                    style={{
                        width: '100%',
                        marginRight: '30px',
                        display: 'flex',

                        flexDirection: 'column',
                    }}
                >
                    <div>
                        <Input
                            value={value}
                            min={min}
                            max={max}
                            step={step}
                            maxLength={maxLength}
                            onChange={onChange}
                            currencyLabel={currencyLabel}
                        />
                    </div>
                    <Slider
                        min={min}
                        max={max}
                        step={step}
                        value={value}
                        onChange={onChange}
                        trackStyle={{ backgroundColor: '#3700ff' }}
                        handleStyle={{ height: '20px', width: '20px', marginTop: '-8px', borderColor: '#E1E3E8' }}
                    />
                </div>
            </div>
        </div>
    );
};

export default SliderValue;
